/** The retired internal warehouse Overview dashboard's entity type, which was also its
 *  view-control namespace. */
export const RETIRED_GOLD_OVERVIEW_TYPE = 'goldOverview';

type PersistedTabs = {
  tabs?: { key: string; entityType?: string }[];
  activeTabKey?: string | null;
  dashboardControls?: Record<string, unknown>;
};

/** Drops a retired dashboard's saved tabs and view controls from persisted app state,
 *  and leaves no active tab pointing at a dropped one. */
export const dropRetiredDashboards = <T extends PersistedTabs>(
  state: T,
): T & Required<PersistedTabs> => {
  const tabs = (state.tabs || []).filter(
    (tab) => tab.entityType !== RETIRED_GOLD_OVERVIEW_TYPE,
  );
  const dashboardControls = { ...(state.dashboardControls || {}) };
  delete dashboardControls[RETIRED_GOLD_OVERVIEW_TYPE];
  return {
    ...state,
    tabs,
    activeTabKey: tabs.some((tab) => tab.key === state.activeTabKey)
      ? (state.activeTabKey ?? null)
      : null,
    dashboardControls,
  };
};
